var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "features" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("message.loginlessChat"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("settings.visitorLoginFormSubtitles"))),
      ]),
    ]),
    _vm._v(" "),
    _c("section", [
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          [
            _c("FeatureItem", {
              attrs: {
                description: _vm.$t("message.vtipyCustomLogin"),
                title: _vm.$t("message.customLoginFormSettingsTitle"),
                icon: "VisitorFormIcon",
              },
              model: {
                value: _vm.customLoginForm,
                callback: function ($$v) {
                  _vm.customLoginForm = $$v
                },
                expression: "customLoginForm",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "customLoginForm" }, [
              _vm.customLoginForm
                ? _c("div", [_c("CustomLoginForm")], 1)
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }